/**
 * Statement queries are historical as-of reports. A caller may request a
 * future end date (for example, the current calendar year's December 31), but
 * rows submitted after the organization's current local day are not yet part
 * of that report.
 */
export function clampStatementEndDate(
  requestedEndDate: string | null | undefined,
  organizationToday: string,
): string {
  const requested = requestedEndDate?.trim() || organizationToday;
  return requested > organizationToday ? organizationToday : requested;
}

/**
 * The calendar year a statement period starts in, read from the YYYY-MM-DD
 * string directly. `new Date("2026-01-01").getFullYear()` is 2025 in every US
 * time zone (UTC midnight is still Dec 31 locally), which stored a member's
 * 2026 statement as "2025". Anything that isn't a plain date falls back to the
 * Date parser, as before.
 */
export function getStatementYear(startDate: string): number {
  const year = Number.parseInt(startDate.slice(0, 4), 10);
  return Number.isFinite(year) ? year : new Date(startDate).getFullYear();
}

export function getStatementYearDateRange(
  statementYear: number,
  organizationToday: string,
): { startDate: string; endDate: string } {
  return {
    startDate: `${statementYear}-01-01`,
    endDate: clampStatementEndDate(`${statementYear}-12-31`, organizationToday),
  };
}
